<template>
    <div>
        <div class="row">
            <div class="col-5">
                <b>{{ question }}</b>
            </div>
            <div class="col-7">
                <ValidationProvider
                  v-slot="{ errors, validated }"
                  rules="required"
                >
                    <CustomRadioButtonGroup
                        v-model="model.answer"
                        :options="options"
                        :disabled="disabled"
                        :has-error="validated && !!errors.length"
                        error-message="Al menos una opción es requerida"
                    />
                </ValidationProvider>
            </div>
        </div>
    </div>
</template>
<script>
import CustomRadioButtonGroup from "@/views/pei/atEquipment/common/CustomRadioButtonGroup.vue";
import { ValidationProvider } from "vee-validate";
  
export default {  
    name: "KeepNextYearQuestion",
    components: {
        ValidationProvider,
        CustomRadioButtonGroup
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                answer: "",
                comment: "",
            }),
        },
        question: {
            type: String,
            required: true,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        model: {
            answer: "",
            comment: "",
        },
        options: [
            { label: 'Sí', value: 'yes' },
            { label: 'No', value: 'no' },
        ]
    }),
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.model.answer = newValue.answer;
                this.model.comment = newValue.comment;
            }
        },
        model: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
    },
};
</script>

<style scoped>
</style>